import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ProtectedRoute } from './pages/login/auth/protected.route';
import LoginIndex from './pages/login/index'
import AdminIndex from './pages/admin/index'
// import AttendanceGridIndex from './pages/attendances/grid-index'
// import DashboardGridIndex from './pages/dashboard/grid-index'
import DepositGridIndex from './pages/deposits/grid-index'
import ActivityGridIndex from './pages/activities/grid-index'
import CashAccountGridIndex from './pages/cash_accounts/grid-index'
import RoomGridIndex from './pages/rooms/grid-index'
import MenuOrderGridIndex from './pages/menu_orders/grid-index'
import Homepage from './pages/homepage'
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function App() {
  return (
    <BrowserRouter basename={'/'}>
      <Switch>
        {/* <Route exact path={`${process.env.PUBLIC_URL}/`} component={AdminIndex}/> */}
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={LoginIndex}/>
        {/* <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard/attendance`} component={AttendanceGridIndex}/> */}
        <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard/cash_accounts`} component={CashAccountGridIndex}/>
        {/* <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard`} component={DashboardGridIndex}/> */}
        <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard`} component={Homepage}/>
        <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard/transactions`} component={DepositGridIndex}/>
        <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard/activities`} component={ActivityGridIndex}/>
        <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard/rooms`} component={RoomGridIndex}/>
        <ProtectedRoute exact path={`${process.env.PUBLIC_URL}/dashboard/orders`} component={MenuOrderGridIndex}/>
        {/* <Route exact path={`${process.env.PUBLIC_URL}/dashboard/admin`} component={AdminIndex}/> */}
      </Switch>
    </BrowserRouter>
  );
}

export default App;
